export default {
  error_5: "系统错误",
  error_no_permission: "没有权限",
  error_invalid_email: "无效邮箱",
  error_invalid_phone: "无效手机号",
};
